// extracted by mini-css-extract-plugin
export default {"container":"contactInfo_container__Akk4K","wrapper":"contactInfo_wrapper__baw+J"};